module.exports = __webpack_public_path__ + "media/img/pages/career-starter/regions/bern-fr-6be19c24c9296f3ea2542c83eee91687.png";